import { render, staticRenderFns } from "./MedicalIssues.vue?vue&type=template&id=6f420b3c&scoped=true&"
import script from "./MedicalIssues.vue?vue&type=script&lang=js&"
export * from "./MedicalIssues.vue?vue&type=script&lang=js&"
import style0 from "./MedicalIssues.vue?vue&type=style&index=0&id=6f420b3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f420b3c",
  null
  
)

export default component.exports